var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfigurationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M1.5 2.5h19a2 2 0 0 1 2 2v17h-19c-1.1 0-2-.895-2-2v-17Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3.5 2.5v17h19v2h-19c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 1.5 19.5v-17h2Zm19 8v7.75h-5.08V10.5h5.08Zm-6.33-7v14.75h-5.08V3.5h5.08ZM9.84 7.75v10.5H4.76V7.75h5.08Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M18.67 14.75v-3h2.58v3h-2.58Zm-6.33-6.5v-3.5h2.58v3.5h-2.58ZM6.01 13V9h2.58v4H6.01Z"
}))));
export default SvgConfigurationIcon;